import React, { useState, useEffect } from "react";
import { Table, Empty, Col, Row } from "antd";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import RequestHandler from "../../util/RequestHandler";
import MonthlyStatusReportTableFilter from "../Filters/MonthlyStatusReportTableFilter";
import { ColumnHelper } from "../../util/TableHelper";
import { odata, queryHelper } from "../Filters/Helper";

const MonthlyStatusReport = (props) => {
  const defaultQueryData = {
    pageSize: 15,
  };
  const [tableData, setTableData] = useState({
    data: [],
    currencyCode: "TRY",
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [isDigitStatusFromDate, setIsDigitStatusFromDate] = useState();

  const [totalAmount, setTotalAmount] = useState(0);

  const history = useHistory();

  useEffect(() => {
    setFilterValues();
    getTableData();
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then((response) => {
      if (response.success) {
        setIsDigitStatusFromDate(response.data.isDigitStatusFromDate)
      }
    });
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.post(
      `/Reports/GetMonthlyStatusPlanReports`,
      tableDataQueryOptions.values,
      false
    ).then((response) => {
      const amountTotal = response[0]
        ? ColumnHelper.renderDecimal(response[0]?.accountBalanceTotal)
        : "-";
      setTotalAmount(amountTotal);

      setTableData({
        data: response,
        currencyCode: tableDataQueryOptions.values.currencyCode
          ? tableDataQueryOptions.values.currencyCode
          : "TRY",
        total: response.length,
        loading: false,
      });
    });

    if (props.onFilterChange) {
      props.onFilterChange(tableDataQueryOptions);
    }
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        pageSize: p.pageSize,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    delete values["dateRange"];

    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const GoReportDetailFirmPageCollect = (value) => {
    history.push(`report-monthly-firm-details/${value}`);
  };

  const GoReportDetailFirmPagePayment = (value) => {
    history.push(`report-monthly-firm-details-payment/${value}`);
  };

  const columns = [
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDate",
      align: "center",
      width: "10%",
      render: (text, record) => {
        return text == null
          ? " - "
          : moment(
              text.split("/")[0] +
                (text.split("/")[1].length > 1
                  ? text.split("/")[1]
                  : "0" + text.split("/")[1]) +
                "13"
            ).format("MMM YYYY");
      },
    },
    {
      title: "Tahsilat Planı",
      dataIndex: "collectPlanTotal",
      key: "collectPlanTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Gerçekleşen Tahsilat",
      dataIndex: "collectTotal",
      key: "collectTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                 {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Kalan Tahsilat",
      dataIndex: "collectMounthTotal",
      key: "collectMounthTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null || text.toString().includes("-") === true) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Ödeme Planı",
      dataIndex: "paymentPlanTotal",
      key: "paymentPlanTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Gerçekleşen Ödeme",
      dataIndex: "paymentTotal",
      key: "paymentTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Kalan Ödeme",
      dataIndex: "paymentMounthTotal",
      key: "paymentMounthTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null || text.toString().includes("-") === true) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Tahmini Bakiye",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) => {
        return record.accountBalanceMonthlyTotal === 0 ? (
          "-"
        ) : (
          <CurrencyFormat
            value={isDigitStatusFromDate ? record.accountBalanceMonthlyTotal : record.accountBalanceMonthlyTotal.toString().split(".")[0]}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
          />
        );
      },
    },
    {
      title: "Tahsilat Detay",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) => (
        <a
          onClick={() => {
            GoReportDetailFirmPageCollect(
              record.transactionDate.split("/")[0] +
                "-" +
                record.transactionDate.split("/")[1] +
                "/" +
                tableData.currencyCode
            );
          }}
          style={{ fontSize: "130%" }}
        >
          <MenuUnfoldOutlined />
        </a>
      ),
    },
    {
      title: "Ödeme Detay",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) => (
        <a
          onClick={() => {
            GoReportDetailFirmPagePayment(
              record.transactionDate.split("/")[0] +
                "-" +
                record.transactionDate.split("/")[1] +
                "/" +
                tableData.currencyCode
            );
          }}
          style={{ fontSize: "130%", color: "red" }}
        >
          <MenuUnfoldOutlined />
        </a>
      ),
    },
  ];

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);
    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  return (
    <>
      <Row>
        <Col span={24} style={{ textAlign: "end", fontSize: 19 }}>
          Güncel Bakiye : {isDigitStatusFromDate ? totalAmount : totalAmount.toString().split(",")[0]} {tableData.currencyCode}
        </Col>
      </Row>

      <MonthlyStatusReportTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        monthly={true}
        extraText="Varsayılan olarak bu aydan itibaren 12 ay ve TRY para birimi listelenmektedir."
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(_, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.pageSize,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default MonthlyStatusReport;
